import React from 'react'

interface EcosystemIconProps {
  ecosystem: string
  className?: string
  size?: number
}

const EcosystemIcon: React.FC<EcosystemIconProps> = ({ecosystem, className = 'me-2', size = 16}) => {
  if (!ecosystem || typeof ecosystem !== 'string') {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke='#111827'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={`text-muted ${className}`}
      >
        <path d='M12 2L2 7l10 5 10-5-10-5z' />
        <path d='M2 17l10 5 10-5' />
        <path d='M2 12l10 5 10-5' />
      </svg>
    )
  }

  switch (ecosystem.toLowerCase()) {
    case 'npm':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={className}
        >
          <path d='M2 8h20v8H2z' />
          <path d='M6 12h4v4H6z' />
        </svg>
      )
    case 'js':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={className}
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M14 3v4a1 1 0 0 0 1 1h4' />
          <path d='M3 15h3v4.5a1.5 1.5 0 0 1 -3 0' />
          <path d='M9 20.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75' />
          <path d='M5 12v-7a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-1' />
        </svg>
      )
    case 'ts':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={className}
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M14 3v4a1 1 0 0 0 1 1h4' />
          <path d='M5 12v-7a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-1' />
          <path d='M14 3v4a1 1 0 0 0 1 1h4' />
          <path d='M9 20.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75' />
          <path d='M3.5 15h3' />
          <path d='M5 15v6' />
        </svg>
      )
    case 'cloud':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={className}
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M6.657 18c-2.572 0 -4.657 -2.007 -4.657 -4.483c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.913 0 3.464 1.56 3.464 3.486c0 1.927 -1.551 3.487 -3.465 3.487h-11.878' />
        </svg>
      )

    case 'aws':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={className}
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M3 7l8 4l8 -4l-8 -4l-8 4z' />
          <path d='M3 17l8 4l8 -4l-8 -4l-8 4z' />
          <path d='M3 12l8 4l8 -4l-8 -4l-8 4z' />
        </svg>
      )

    case 'azure':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={className}
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M6.657 18c-2.572 0 -4.657 -2.007 -4.657 -4.483c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.913 0 3.464 1.56 3.464 3.486c0 1.927 -1.551 3.487 -3.465 3.487h-11.878' />
        </svg>
      )

    case 'gcp':
    case 'google':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={className}
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M12 2L2 7l10 5 10-5-10-5z' />
          <path d='M2 17l10 5 10-5' />
          <path d='M2 12l10 5 10-5' />
        </svg>
      )

    case 'kubernetes':
    case 'k8s':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={className}
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0' />
          <path d='M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0' />
          <path d='M12 14m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0' />
          <path d='M10 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0' />
          <path d='M14 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0' />
        </svg>
      )

    case 'docker':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={className}
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M22 12.5c-4.5 0 -8.5 -1.5 -11 -4.5c-2.5 -3 -3.5 -7 -3.5 -11.5h-7v18h18c0 -4 -0.5 -7.5 -2 -11' />
          <path d='M18 12.5c-1 0 -2 -1 -2 -2s1 -2 2 -2s2 1 2 2s-1 2 -2 2' />
        </svg>
      )

    case 'python':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={className}
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M12 2L2 7l10 5 10-5-10-5z' />
          <path d='M2 17l10 5 10-5' />
          <path d='M2 12l10 5 10-5' />
        </svg>
      )

    case 'java':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={className}
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M14 3v4a1 1 0 0 0 1 1h4' />
          <path d='M5 12v-7a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-1' />
          <path d='M8 9h1' />
          <path d='M8 13h1' />
          <path d='M8 17h1' />
          <path d='M12 9h1' />
          <path d='M12 13h1' />
          <path d='M12 17h1' />
        </svg>
      )

    case 'go':
    case 'golang':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={className}
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M12 2L2 7l10 5 10-5-10-5z' />
          <path d='M2 17l10 5 10-5' />
          <path d='M2 12l10 5 10-5' />
        </svg>
      )

    case 'rust':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={className}
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M12 2L2 7l10 5 10-5-10-5z' />
          <path d='M2 17l10 5 10-5' />
          <path d='M2 12l10 5 10-5' />
        </svg>
      )

    case 'php':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={className}
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M12 2L2 7l10 5 10-5-10-5z' />
          <path d='M2 17l10 5 10-5' />
          <path d='M2 12l10 5 10-5' />
        </svg>
      )

    case 'ruby':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={className}
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M12 2L2 7l10 5 10-5-10-5z' />
          <path d='M2 17l10 5 10-5' />
          <path d='M2 12l10 5 10-5' />
        </svg>
      )

    case 'csharp':
    case 'c#':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={className}
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M12 2L2 7l10 5 10-5-10-5z' />
          <path d='M2 17l10 5 10-5' />
          <path d='M2 12l10 5 10-5' />
        </svg>
      )

    case 'cpp':
    case 'c++':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={className}
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M12 2L2 7l10 5 10-5-10-5z' />
          <path d='M2 17l10 5 10-5' />
          <path d='M2 12l10 5 10-5' />
        </svg>
      )
    case 'yarn':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={className}
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M12 2L2 7l10 5 10-5-10-5z' />
          <path d='M2 17l10 5 10-5' />
          <path d='M2 12l10 5 10-5' />
        </svg>
      )

    case 'pnpm':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={className}
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M12 2L2 7l10 5 10-5-10-5z' />
          <path d='M2 17l10 5 10-5' />
          <path d='M2 12l10 5 10-5' />
        </svg>
      )

    case 'pip':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={className}
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M12 2L2 7l10 5 10-5-10-5z' />
          <path d='M2 17l10 5 10-5' />
          <path d='M2 12l10 5 10-5' />
        </svg>
      )

    case 'maven':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={className}
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M12 2L2 7l10 5 10-5-10-5z' />
          <path d='M2 17l10 5 10-5' />
          <path d='M2 12l10 5 10-5' />
        </svg>
      )

    case 'gradle':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={className}
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M12 2L2 7l10 5 10-5-10-5z' />
          <path d='M2 17l10 5 10-5' />
          <path d='M2 12l10 5 10-5' />
        </svg>
      )

    case 'nuget':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={className}
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M12 2L2 7l10 5 10-5-10-5z' />
          <path d='M2 17l10 5 10-5' />
          <path d='M2 12l10 5 10-5' />
        </svg>
      )
    default:
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 24 24'
          fill='none'
          stroke='#111827'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={`text-muted ${className}`}
        >
          <path d='M12 2L2 7l10 5 10-5-10-5z' />
          <path d='M2 17l10 5 10-5' />
          <path d='M2 12l10 5 10-5' />
        </svg>
      )
  }
}

export default EcosystemIcon
